import type { Dispatch, SetStateAction } from 'react';
import { createContext, useContext } from 'react';

export const StackScreenContext = createContext<{
  id: string;
  title: string;
  setTitle: Dispatch<SetStateAction<string>>;
}>({
  id: '',
  title: '',
  setTitle: () => {},
});

export function useStackScreenContext() {
  const context = useContext(StackScreenContext);
  if (!context) {
    console.error('useStackScreenContext is being usied outside of a StackScreenProvider');
  }
  return context;
}

export function getHeaderRightPortalId(routeId: string) {
  return `${routeId}-header-right-portal`;
}

export function useStackableRouteHeaderRightPortalId() {
  const { id: currentStackId } = useStackScreenContext();
  if (!currentStackId) {
    console.error(
      'useStackableRouteHeaderRightPortalId is being used outside of a StackScreenContext, this means you are rendering a StackScreen with no StackScreenContext'
    );

    return '';
  }
  return getHeaderRightPortalId(currentStackId);
}
